import { createContext } from "react";

const TempleContext = createContext({});

export default TempleContext;
